import { IonButton } from "@ionic/react";
import React, { useEffect, useState } from "react";

interface BeforeInstallPromptEvent extends Event {
  readonly platforms: string[];
  readonly userChoice: Promise<{
    outcome: 'accepted' | 'dismissed';
    platform: string;
  }>;
  prompt(): Promise<void>;
}

const InstallPWA = () => {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState<BeforeInstallPromptEvent | null>(null);

  useEffect(() => {
    const handler = (e: BeforeInstallPromptEvent) => {
      e.preventDefault();
      console.log("we are being triggered :D");
      setSupportsPWA(true);
      setPromptInstall(e);
    };
    window.addEventListener("beforeinstallprompt", handler as any);

    return () => window.removeEventListener("beforeinstallprompt", handler as any);
  }, []);

  const onClick = (evt: React.MouseEvent<HTMLIonButtonElement>) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
  };
  if (!supportsPWA) {
    return null;
  }
  return (
    <IonButton
          expand="block"
          className="link-button"
          id="setup_button"
          aria-label="Install app"
          title="Installera app"
          color="success"
          onClick={onClick} placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}    >Installera appen</IonButton>
  );
};

export default InstallPWA;